import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgDocSanitizeHtmlPipe } from '@ng-doc/app/pipes';
import { NgDocTabGroupComponent, NgDocTabComponent, NgDocExecutePipe, NgDocIconComponent, NgDocBindPipe } from '@ng-doc/ui-kit';
function NgDocTabsComponent_ng_doc_tab_2_ng_template_1_ng_doc_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 7);
  }
  if (rf & 2) {
    const tab_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("customIcon", tab_r1.icon);
  }
}
function NgDocTabsComponent_ng_doc_tab_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgDocTabsComponent_ng_doc_tab_2_ng_template_1_ng_doc_icon_0_Template, 1, 1, "ng-doc-icon", 6);
    i0.ɵɵtext(1);
  }
  if (rf & 2) {
    const tab_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngIf", tab_r1.icon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tab_r1.title, " ");
  }
}
function NgDocTabsComponent_ng_doc_tab_2_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "execute");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const element_r2 = i0.ɵɵreference(1);
    const tab_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(3, 1, ctx_r2.appendElement, tab_r1.content, element_r2), " ");
  }
}
function NgDocTabsComponent_ng_doc_tab_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-doc-tab", 5);
    i0.ɵɵtemplate(1, NgDocTabsComponent_ng_doc_tab_2_ng_template_1_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, NgDocTabsComponent_ng_doc_tab_2_ng_template_3_Template, 4, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r4 = ctx.index;
    const label_r5 = i0.ɵɵreference(2);
    const content_r6 = i0.ɵɵreference(4);
    i0.ɵɵproperty("label", label_r5)("content", content_r6)("id", i_r4);
  }
}
let NgDocTabsComponent = /*#__PURE__*/(() => {
  class NgDocTabsComponent {
    constructor() {
      this.tabs = [];
    }
    getActiveIndex(tabs) {
      return Math.max(tabs.findIndex(tab => tab.active), 0);
    }
    appendElement(element, parent) {
      parent.appendChild(element);
    }
    static {
      this.ɵfac = function NgDocTabsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocTabsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocTabsComponent,
        selectors: [["ng-doc-tabs"]],
        inputs: {
          tabs: "tabs"
        },
        decls: 3,
        vars: 5,
        consts: [["label", ""], ["content", ""], ["element", ""], [3, "openedTab"], [3, "label", "content", "id", 4, "ngFor", "ngForOf"], [3, "label", "content", "id"], [3, "customIcon", 4, "ngIf"], [3, "customIcon"]],
        template: function NgDocTabsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ng-doc-tab-group", 3);
            i0.ɵɵpipe(1, "execute");
            i0.ɵɵtemplate(2, NgDocTabsComponent_ng_doc_tab_2_Template, 5, 3, "ng-doc-tab", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("openedTab", i0.ɵɵpipeBind2(1, 2, ctx.getActiveIndex, ctx.tabs));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.tabs);
          }
        },
        dependencies: [CommonModule, i1.NgForOf, i1.NgIf, NgDocTabGroupComponent, NgDocTabComponent, NgDocExecutePipe, NgDocIconComponent],
        styles: ["[_nghost-%COMP%]{display:block;border-radius:var(--ng-doc-tabs-border-radius);border:var(--ng-doc-tabs-border);margin:var(--ng-doc-tabs-margin);overflow:hidden;--ng-doc-code-margin: 0;--ng-doc-code-border-radius: 0;--ng-doc-code-border: none;--ng-doc-tab-group-header-background: var(--ng-doc-base-2)}[_nghost-%COMP%]   ng-doc-icon[_ngcontent-%COMP%]{margin-right:calc(var(--ng-doc-base-gutter) / 2)}"],
        changeDetection: 0
      });
    }
  }
  return NgDocTabsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocTabsComponent };
